import React from 'react';
import { AppDefaultData } from './AppDefaultData';

// Create Context
export const AppContext = React.createContext({ contextData: AppDefaultData, setContextData: null });